export const START_FETCH_LABELS_CONFIG_LIST = "START_FETCH_LABELS_CONFIG_LIST";
export const SUCCESS_FETCH_LABELS_CONFIG_LIST = "SUCCESS_FETCH_LABELS_CONFIG_LIST";
export const ERROR_FETCH_LABELS_CONFIG_LIST = "ERROR_FETCH_LABELS_CONFIG_LIST";
export const SET_SELECTED_LANG = "SET_SELECTED_LANG";
